export default {
  data() {
    return {
      // Validação comum - padrão, chamar apenas uma sem []
      nameRules: [
        v => !!v || "Nome é obrigatório",
        v => (v && v.length <= 40) || "Name must be less than 40 characters"
      ],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      required: [v => !!v || "Campo obrigatório"]
    };
  },
  methods: {
    // Validação individual, chamar muliplas dentro de [method(), method(param)]
    ruleRequired(msg) {
      return v => !!v || msg;
    },
    ruleMail() {
      return v => /.+@.+\..+/.test(v) || "E-mail inválido";
    },
    ruleMaxLen(max) {
      return v => (v && v.length <= max) || "Máx " + max + " characters";
    },
    ruleMinLen(min) {
      return v => (v && v.length >= min) || "Min " + min + " characters";
    },
    ruleMatch(value2Match) {
      return v => (v && v == value2Match) || "Não combina";
    }
  }
};
